export function convertGraduationYearToLabel(graduationYear: number): string {
  const lastTwoDigits = graduationYear % 100;
  return `${lastTwoDigits}卒`;
}
